import { Role } from "@eave/shared/types/api";
import { tokenHasRoles } from "./session";

export const navPaths = {
  root: "/reporting",
  pipeline: "/reporting/pipeline",
  app: "/underwriter",
  queues: "/underwriter/queues",
  tools: "/tools",
};

export interface HeaderLink {
  name: string;
  to: string;
}

const allLinks: HeaderLink[] = [
  {
    name: "Loans",
    to: navPaths.app,
  },
  {
    name: "Queues",
    to: navPaths.queues,
  },
  {
    name: "Pipeline",
    to: navPaths.pipeline,
  },
  {
    name: "Tools",
    to: navPaths.tools,
  },
];

export const getHeaderLinksForUser = (token): HeaderLink[] => {
  if (
    tokenHasRoles(
      token,
      Role.Admin,
      Role.OpsAdmin,
      Role.CapitalMarkets,
      Role.LoanOfficer,
      Role.Underwriter,
    )
  ) {
    return allLinks;
  }
  if (tokenHasRoles(token, Role.CashClose)) {
    return [
      {
        name: "Pipeline",
        to: navPaths.pipeline,
      },
    ];
  }
  if (tokenHasRoles(token, Role.CashCloseAdmin)) {
    return [
      {
        name: "Pipeline",
        to: navPaths.pipeline,
      },
      {
        name: "Tools",
        to: navPaths.tools,
      },
    ];
  }
  return [];
};
